// ProductsSection.js
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { productSegments as segments } from '../productsSegment';
// import { getData as exteriorData } from '../Data/Exterior/GetData';
// import { getData as interiorData } from '../Data/Interior/GetData';
// import {getData as defaultData} from '../Data/Primer/GetData'
// import {getData as distemperData} from '../Data/Distemper/GetData'
// import {getData as puttyData} from '../Data/Putty/GetData'
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore'
import { Usercontext } from '../App';

import '../css/productsSection.css';
import customButton from '../css/Button.module.css';
import '../css/mediaQueries.css';
// import { all } from 'axios';

export default function ProductsSection() {
  const [activeIndex, setActiveIndex] = useState(0);

  const {userdata} = useContext(Usercontext)

  const allData = useMemo(()=>(
    {
      'Exterior' : [],
      'Primer' : [],
      'Interior' : [],
      'Distemper' : [],
      'Putty' : [],
      'Texture' : []
    }
  ),[])
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const [selectedSectionData,setSelectedSectionData] = useState("Primer")

  const changeData = useCallback((importedData) => {
    setData(() => importedData);
  }, [setData]);

  const details = (item) => {
    console.log(item);

    navigate('/details', { state: item }); // Navigate to the details page
  };

  const getData = async(section)=>{

      const collection = await firebase.firestore().collection(section).get()

      collection.docs.forEach((doc)=>{
        allData[section].push({id : doc.id,...doc.data()})
      })
      console.log("All Data : ",allData)
      setData(()=>(allData[section]))
    }


  const hasRun = useRef(false)
  useEffect(()=>{
    
    if(hasRun.current)
      return 
    
      getData("Primer")
      hasRun.current = true
  },[])


  return (
    <div id="products-section" className="products-section" style={{  backgroundImage: `var(--background-image)`,   backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center',transition: 'background-image 0.5s ease-in-out'}}>
      <div className="container">
        {/* Button Group */}
        <div className={`${customButton['button-group']}`} role="group" aria-label="Basic example">
          {segments.map((item, index) => (
            <button
              className={`${customButton.button} ${activeIndex === index ? customButton.active : ''}`}
              key={index}
              onClick={async () => {
                setActiveIndex(index);
                try {
                  switch (index) {
                    case 0:
                      // changeData(defaultData);
                        allData['Primer'].length>0 ? changeData(allData['Primer']) : getData('Primer')
                        setSelectedSectionData('Primer')
                      break;
                    case 1:
                      // changeData(interiorData);
                      allData['Interior'].length>0 ? changeData(allData['Interior']) : getData('Interior')
                      setSelectedSectionData('Interior')

                      break;
                    case 2:
                      // changeData(exteriorData);
                      allData['Exterior'].length>0 ? changeData(allData['Exterior']) : getData('Exterior')
                      setSelectedSectionData('Exterior')

                      break;
                    case 3 :
                      // changeData(distemperData);
                      allData['Distemper'].length>0 ? changeData(allData['Distemper']) : getData('Distemper')
                      setSelectedSectionData('Distemper')

                      break;
                    case 4 :
                        // changeData(puttyData);
                        allData['Putty'].length>0 ? changeData(allData['Putty']) : getData('Putty')
                        setSelectedSectionData('Putty')
                        break;
                    case 5 :
                      // changeData([]);
                      allData['Texture'].length>0 ? changeData(allData['Texture']) : getData('Texture')
                      setSelectedSectionData('Texture')
                      
                      break;
                    default:
                      changeData([]);
                  }
                  document.getElementById('row').classList.add('fade-in');
                  setTimeout(() => {
                    document.getElementById('row').classList.remove('fade-in');
                  }, 500);
                } catch (e) {
                  console.log(e);
                  changeData([]);
                }
              }}
            >
              {item}
            </button>
          ))}
        </div>

        {/* Products Grid */}
        <div className="row" id="row" style={{ justifyContent: 'space-evenly', marginTop: '5%', marginBottom: '5%' }}>
        {allData[selectedSectionData].length > 0 ? (
          // {data.length > 0 ? (
            data.map((item) => (
              <div className="card card-main" style={{ width: '18rem', borderRadius: '2rem', marginTop: '1%', flex: 'none', alignSelf: 'start' }} key={item.id}>
                <div style={{ height: '18rem', borderRadius: '2.1rem 2.1rem 0 0' }}>
                  <div className="image-container container">
                    <img style={{ height: '100%', padding: '6%', display: 'block' }} src={(`/Images/${item.segment}/${item.imageURL[0]}`)} className="card-img-top img-fluid img-responsive" alt="..." />
                  </div>
                </div>
                <div className="card-body" style={{ paddingTop: '0rem', paddingBottom: '1rem', flex: 'none' }}>
                  <h5 className="card-title" style={{ fontSize: '22px', marginTop: '1.5rem' }}>{item.name}</h5>
                  <div className="feature-main" style={{ height: '111px' }}>
                    {item.feature.map((feature) => (
                      <div className="feature-inner-main" key={feature}>
                        <img className="feature-img" src={(`/Images/Features/${feature}.png`)} alt={feature} />
                        <p className='card-p feature-text'>{feature}</p>
                      </div>
                    ))}
                  </div>
                  <div>
                    <button onClick={() => {  details(item); }} className={customButton.button} style={{ background: '#06bdf6', width: '100%' }}>View</button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p>No Products Found</p>
          )}
        </div>
      </div>
    </div>
  );
}
